import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    color1: "#000000",
    color2: "#AF9FF7",
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: 14,
  },
  //   components: {
  //     MuiButton: {
  //       styleOverrides: {
  //         root: {
  //           borderRadius: 8,
  //           textTransform: 'none',
  //         },
  //       },
  //     },
  //   },
});

export default theme;
